module.exports = __webpack_public_path__ + "static/media/camera.2989b260.jpg";